// Material Specification Module Data
// Extracted from Material Library Module Data.xlsx

export interface MaterialSpecificationField {
  name: string;
  label: string;
  type: 'select' | 'multiselect' | 'number' | 'text';
  options?: string[];
  placeholder?: string;
  required?: boolean;
}

// Material Top Category 下拉选项 (6个)
export const materialTopCategories = [
  'Woven',
  'Warp Knit',
  'Weft Knit',
  'Flat Knit Yarn',
  'Non-Woven',
  'Non-Textile',
];

// Material Sub Category 下拉选项 (66个)
export const materialSubCategories = [
  'Poplin',
  'Canvas',
  'Broadcloth',
  'Chambray',
  'Gingham',
  'Oxford',
  'Percale',
  'Voile',
  'Georgette',
  'Crepe Plain',
  'Muslin',
  'Calico',
  'Taffeta',
  'Organdy',
  'Batiste',
  'Lawn',
  'Duck cloth',
  'Drill',
  'Denim',
  'Chino',
  'Gabardine',
  'Serge',
  'Herringbone',
  'Twill suiting',
  'Cavalry twill',
  'Bedford cord',
  'Pinstripe twill',
  'Satin',
  'Charmeuse satin',
  'Duchess satin',
  'Crepe satin',
  'Jacquard',
  'Brocade',
  'Damask',
  'Matelassé',
  'Dobby',
  'Pique woven',
  'Leno weave',
  'Single Jersey',
  'Interlock',
  'Rib knit (1x1, 2x2)',
  'French Terry',
  'Loop Terry',
  'Fleece',
  'Pique knit',
  'Ottoman knit',
  'Pointelle knit',
  'Slub jersey',
  'Tricot',
  'Raschel',
  'Power net',
  'Mesh warp knit',
  'Velvet',
  'Velour',
  'Corduroy',
  'Sherpa',
  'Faux fur',
  'Suede fabric',
  'Microsuede',
  'Crepe',
  'Chiffon',
  'Tulle',
  'Netting',
  'Lace',
  'Sequin fabric',
  'Burnout fabric',
];

// Fiber Contents 下拉选项 (56个)
export const fiberContents = [
  'Cotton',
  'Organic Cotton',
  'Recycled Cotton',
  'Linen',
  'Ramie',
  'Hemp',
  'Recycled Hemp',
  'Jute',
  'Bamboo Fiber',
  'Viscose / Rayon',
  'Modal',
  'Lyocell (Tencel)',
  'Cupro',
  'Acetate',
  'Banana Fiber',
  'Soybean Fiber',
  'Corn Fiber',
  'Wool',
  'Merino Wool',
  'Lambswool',
  'Cashmere',
  'Alpaca',
  'Mohair',
  'Angora',
  'Camel Hair',
  'Yak Wool',
  'Silk',
  'Mulberry Silk',
  'Wild Silk',
  'Recycled Wool',
  'Polyester',
  'Recycled Polyester (rPET)',
  'Nylon / Polyamide',
  'Recycled Nylon',
  'Acrylic',
  'Modacrylic',
  'Polypropylene (PP)',
  'Polyethylene (PE)',
  'PBT',
  'PTMEG',
  'Polyurethane (PU)',
  'PVC Fiber',
  'Spandex / Elastane',
  'Lycra',
  'T400',
  'Viscose',
  'Lyocell',
  'Cuprammonium (Cupro)',
  'Triacetate',
  'Glass Fiber',
  'Carbon Fiber',
  'Aramid (Kevlar / Nomex)',
  'Basalt Fiber',
  'Metal Fiber',
  'Conductive Fiber',
  'Flame Retardant Fiber',
];

// Branded Fiber 下拉选项 (11个)
export const brandedFibers = [
  'BCI',
  'CMIA',
  'OCS',
  'GOTS',
  'GRS',
  'RCS',
  'FSC',
  'Lenzing Eco-vero',
  'Birla Liva Eco',
  'Tangshan Eco Tang',
  'Lycra',
];

// Material Finishes 多选选项 (56个 - 机械和化学整理)
export const materialFinishes = [
  'Calendaring',
  'Embossing',
  'Embossing & Debossing',
  'Brushing / Sanding',
  'Sueding',
  'Napping',
  'Raising',
  'Shearing',
  'Peaching / Peach skin finish',
  'Sand wash',
  'Stone wash',
  'Enzyme wash (mechanical action)',
  'Garment wash',
  'Silicon brushing',
  'Raised rib finish',
  'Pre-shrinking / Sanforizing',
  'Compacting',
  'Relaxing',
  'Tentering / Frame setting',
  'Heat setting (mechanical fix)',
  'Decating (Decatizing)',
  'Tubular compacting',
  'Softener finish',
  'Silicon soft finish',
  'Bio-soft finish',
  'Wax finish',
  'Oil finish',
  'Wrinkle resistant / Anti-wrinkle',
  'Permanent press / Easy care',
  'Non-iron finish',
  'Crease recovery finish',
  'Resin finish (cross-link)',
  'Moisture wicking',
  'Quick dry',
  'Hydrophilic / Water absorbent',
  'Cool touch finish',
  'Breathability enhancement',
  'Thermo-regulating finish',
  'Water repellent (DWR)',
  'Waterproof',
  'Oil repellent / Stain repellent',
  'Soil release',
  'Anti-fouling',
  'Windproof finish',
  'Flame retardant (FR)',
  'Anti-static',
  'UV protection / Anti-UV',
  'Anti-microbial / Anti-bacterial',
  'Anti-odor',
  'Insect repellent / Mosquito repellent',
  'Anti-mildew / Anti-fungus',
  'Optical brightener (OB)',
  'Color fixation / Anti-fade',
  'Rub fastness improvement',
  'Chlorine resistant finish',
  'Light fastness enhancement',
];

// Fabric Density 下拉选项 (4个)
export const fabricDensities = [
  'Warp pick per inch',
  'Weft pick per inch',
  'Wales',
  'Course',
];

// Impression Intents 下拉选项 (4个)
export const impressionIntents = [
  'Solid',
  'Yarn Dye',
  'AOP (all-over print)',
  'Fiber Dye',
];

// Material Function 下拉选项 (24个)
export const materialFunctions = [
  'Moisture Wicking / Wicks Sweat',
  'Quick Dry / Fast Drying',
  'Hydrophilic / Water Absorbent',
  'Breathable / High Airflow',
  'Cooling / Cool Touch (Qmax)',
  'Moisture Permeable (Waterproof-Breathable)',
  'Sweat Resistant',
  'Ventilated / Enhanced Air Circulation',
  'Thermal Insulation / Warmth Retention',
  'Lightweight Warmth',
  'Heat Retentive',
  'Self-Heating / Moisture-Absorbing Heat',
  'Phase Change Material (PCM) / Temperature Regulating',
  'Coolmax / Thermo-Cool',
  'Heat Reflective',
  'Waterproof (e.g., 5k/10k/20k mm H₂O)',
  'Durable Water Repellent (DWR)',
  'Water Repellent / Shower Resistant',
  'Windproof / Wind Resistant',
  'Stain Repellent / Anti-Stain',
  'Oil Repellent / Anti-Oil',
  'Soil Release / Easy Clean',
  'UV Protection / UPF 50+ (Blocks 98%+ UV)',
  'Anti-Fading (Light Fastness)',
];

// Sustainable 下拉选项 (2个)
export const sustainableOptions = [
  'Yes',
  'No',
];

// Customer 下拉选项 (9个) - 允许多选
export const customerOptions = [
  'BPH',
  'WITT',
  'ERF',
  'Lascana',
  'Adler',
  'HSE',
  'Manor',
  'QVC',
  'Otto Fashion & Sports',
];

// Material Specification 字段配置
export const materialSpecificationFields: MaterialSpecificationField[] = [
  {
    name: 'materialTopCategory',
    label: 'Material Top Category',
    type: 'select',
    options: materialTopCategories,
    placeholder: 'Select or search top category...',
    required: true,
  },
  {
    name: 'materialSubCategory',
    label: 'Material Sub Category',
    type: 'select',
    options: materialSubCategories,
    placeholder: 'Select or search sub category...',
    required: true,
  },
  {
    name: 'fiberContents',
    label: 'Fiber Contents',
    type: 'select',
    options: fiberContents,
    placeholder: 'Select or search fiber content...',
    required: true,
  },
  {
    name: 'brandedFiber',
    label: 'Branded Fiber',
    type: 'select',
    options: brandedFibers,
    placeholder: 'Select or search branded fiber...',
    required: false,
  },
  {
    name: 'finishedWeight',
    label: 'Finished Weight (GSM)',
    type: 'number',
    placeholder: 'Enter weight in GSM...',
    required: true,
  },
  {
    name: 'materialFinishes',
    label: 'Material Finishes (Including both mechanical and chemical)',
    type: 'multiselect',
    options: materialFinishes,
    placeholder: 'Select finishes...',
    required: false,
  },
  {
    name: 'fabricDensity',
    label: 'Fabric Density',
    type: 'select',
    options: fabricDensities,
    placeholder: 'Select or search fabric density...',
    required: false,
  },
  {
    name: 'materialWidth',
    label: 'Material Width (inch)',
    type: 'number',
    placeholder: 'Enter width in inches...',
    required: true,
  },
  {
    name: 'cuttableWidth',
    label: 'Cuttable Width (inch)',
    type: 'number',
    placeholder: 'Enter cuttable width in inches...',
    required: false,
  },
  {
    name: 'impressionIntents',
    label: 'Impression Intents',
    type: 'select',
    options: impressionIntents,
    placeholder: 'Select or search impression intent...',
    required: false,
  },
  {
    name: 'comments',
    label: 'Comments Section for remarks',
    type: 'text',
    placeholder: 'Enter comments...',
    required: false,
  },
  {
    name: 'materialFunction',
    label: 'Material Function (Able to Claim)',
    type: 'select',
    options: materialFunctions,
    placeholder: 'Select or search material function...',
    required: false,
  },
  {
    name: 'sustainable',
    label: 'Sustainable',
    type: 'select',
    options: sustainableOptions,
    placeholder: 'Select sustainable option...',
    required: false,
  },
  {
    name: 'careRecommendations',
    label: 'Care Recommendations',
    type: 'text',
    placeholder: 'Enter care recommendations...',
    required: false,
  },
  {
    name: 'customers',
    label: 'Customer',
    type: 'multiselect',
    options: customerOptions,
    placeholder: 'Select customers...',
    required: false,
  },
];

// 默认值
export const defaultMaterialSpecification = {
  materialTopCategory: '',
  materialSubCategory: '',
  fiberContents: [{ percentage: '100', content: '' }],
  brandedFibers: [''],
  finishedWeight: '',
  materialFinishes: [],
  fabricDensity: [
    { density: '', number: '', gauge: '' },
    { density: '', number: '', gauge: '' },
  ],
  materialWidth: '',
  cuttableWidth: '',
  impressionIntents: [],
  comments: '',
  materialFunction: '',
  sustainable: '',
  careRecommendations: '',
  customers: [],
};
